import { call, put, select } from "redux-saga/effects";
import { worker } from "legacy/sagas/evaluationLoader";
import { getWidgets } from "legacy/selectors/entitiesSelector";
import { EVAL_WORKER_ACTIONS } from "legacy/utils/DynamicBindingUtils";
import apiDSLReplayManager from "legacy/workers/replay/ApiDSLReplayManager";
import { selectAllV2Apis } from "store/slices/apisV2/selectors";
import { getAllEvents } from "store/slices/application/events/selectors";
import { getAllStateVars } from "store/slices/application/stateVars/selectors";
import { getAllTimers } from "store/slices/application/timers/selectors";
import {
  setUndoStackIndexAtRequestStart,
  setStateAtRequestStart,
} from "../slice";
import type { WidgetMap } from "legacy/widgets";

export function* doSetupBeforeClarkRequestSaga(action: {
  payload: { isRedo?: boolean };
}) {
  const isRedo = action.payload.isRedo ?? false;

  // Right now we only need to do this for the first request, not redo requests
  if (isRedo) {
    return;
  }

  // state vars, events, timers, etc. are also undone by the widget undo stack
  const widgetsUndoStackLength: number = yield call(
    worker.request,
    EVAL_WORKER_ACTIONS.GET_UNDO_STACK_LENGTH,
    {},
  );
  const widgetsAtRequestStart: WidgetMap = yield select(getWidgets);

  // loop through all apis and get the undo stack length
  const currentAPIs: ReturnType<typeof selectAllV2Apis> =
    yield select(selectAllV2Apis);
  const apisUndoStackLengths = Object.keys(currentAPIs).reduce(
    (acc, apiId) => {
      acc[apiId] = apiDSLReplayManager.getUndoStackLength(apiId);
      return acc;
    },
    {} as Record<string, number>,
  );

  yield put(
    setUndoStackIndexAtRequestStart({
      widgetsUndoStackLength,
      apisUndoStackLengths,
    }),
  );

  const stateVariablesAtRequestStart: ReturnType<typeof getAllStateVars> =
    yield select(getAllStateVars);

  const timersAtRequestStart: ReturnType<typeof getAllTimers> =
    yield select(getAllTimers);
  const eventsAtRequestStart: ReturnType<typeof getAllEvents> =
    yield select(getAllEvents);

  // TODO: Ai team: We can likely just store the widgets and apis that we operating on
  // and not the entire state for widgets and apis
  yield put(
    setStateAtRequestStart({
      widgetsAtRequestStart: widgetsAtRequestStart,
      apisAtRequestStart: currentAPIs,
      stateVariablesAtRequestStart,
      timersAtRequestStart,
      eventsAtRequestStart,
    }),
  );
}
